import { safeDefine } from "../../registration/safe-define.js";
import { ControlsContentElement } from "../../ui/controls/content.js";
//#region src/define/ui/controls-content.ts
safeDefine(ControlsContentElement);
//#endregion
